import type { CommonContent } from "../types";

export const common: CommonContent = {
  brand: "Padangos-Andze1",
  brandTagline: "Шиномонтаж в Новой Вильне",
  navHome: "Главная",
  navUsedTires: "Б/У Покрышки",
  navMontavimas: "Шиномонтаж и Ремонт",
  navRatlankiai: "Правка Дисков",
  heroTitle: "Продажа и монтаж шин в Новой Вильне",
  heroSubtitle: "По лучшим ценам",
  footerCopyright: "Padangos-Andze1 · A. Semaško I.Į.",
  footerContacts: "Контакты",
  footerLinks: "Ссылки",
};
